import { selectEnv } from 'common-nextjs';

export const bigCatLockerBottomPageViewId = selectEnv(62);
export const bigCatLockerTopPageViewId = selectEnv(59, 11);
